import { connect } from 'react-redux'

import FeaturedSection from 'components/home-page/views/sections/featured'

const mapStateToProps = (state, ownProps) => ({
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(FeaturedSection)
